import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyDUHS1yAZzoxatu4LILlNYxYZ32Xbq3N6g',
  authDomain: 'databaum-284319.firebaseapp.com',
  projectId: 'databaum-284319',
  storageBucket: 'databaum-284319.appspot.com',
  messagingSenderId: '410410414327',
  appId: '1:410410414327:web:b1687067e6c85e8180e3f2',
};

const app = initializeApp(firebaseConfig);

export default app;
